<template>
  <div class="issue-box">
    <div
      class="issue-status flex_s_c_w1"
      :class="{'is_cancel':order_detail.status == 1 || order_detail.status == 4,'is_replay':order_detail.status == 2,'is_online':order_detail.status == 3}"
      v-if="order_detail"
    >
      <img v-if="order_detail.status == 2 || order_detail.status == 3" src="../../../static/icons/paid@3x.png" alt />
      <img v-if="order_detail.status == 1" src="../../../static/icons/close_s@3x.png" alt />
      <img v-if="order_detail.status == 4" src="../../../static/icons/seccess@3x.png" alt />
      <div class="issue-status-txt">{{order_detail.status|charge_status}}</div>
      <div class="issue-status-desc" v-if="order_detail.status == 2">1-3个工作日内退款完成</div>
    </div>
    <div class="issue-list" v-if="order_detail">
      <div class="issue-list-option flex_s_c">
        <div class="issue-left ">订单编号</div>
        <div class="issue-right ">{{order_detail.order_sn}}</div>
      </div>
      <div class="issue-list-option flex_s_c">
        <div class="issue-left ">就诊人</div>
        <div class="issue-right ">{{order_detail.username}}</div>
      </div>
      <div class="issue-list-option flex_s_c">
        <div class="issue-left ">医生</div>
        <div class="issue-right ">{{order_detail.docname}}</div>
      </div>
      <div class="issue-list-option flex_s_c">
        <div class="issue-left ">订单类型</div>
        <div class="issue-right ">{{order_detail.type|order_type}}</div>
      </div>
      <div class="issue-list-option flex_s_c">
        <div class="issue-left ">下单时间</div>
        <div class="issue-right ">{{order_detail.ctime | parse_time}}</div>
      </div>
      <div class="issue-list-option flex_s_c">
        <div class="issue-left ">订单金额</div>
        <div
          class="issue-right  red"
        >¥{{order_detail.charge_amount?numProcess(order_detail.charge_amount):0.00}}</div>
      </div>
    </div>
    <div class="doctor-null flex_s_c_w1" v-if="!order_detail">
      <img src="../../../static/icons/shuju@3x.jpg" alt />
      <div class="doctor-null-txt font-85">暂无数据</div>
    </div>
  </div>
</template>
<script>
import http from "../../request/http";
import { formatDate } from "../../utils/index";
export default {
  data() {
    return {
      order_detail: null,
      order_id: null,
    };
  },
  filters: {
    order_type(val) {
      let txt = "";
      switch (val) {
        case "1":
          txt = "图文问诊";
          break;
        case "2":
          txt = "电话咨询";
          break;
        case "3":
          txt = "视频问诊";
          break;
        default:
          txt = "";
      }
      return txt;
    },
    parse_time(val) {
      return formatDate(val * 1000);
    },
    charge_status(val) {
      let txt = "";
      switch (val) {
        case "1":
          txt = "已取消";
          break;
        case "2":
          txt = "待回复";
          break;
        case "3":
          txt = "问诊中";
          break;
        case "4":
          txt = "已结束";
          break;
        default:
          txt = "";
      }
      return txt;
    },
  },
  created() {
    if (this.$route.query.id) {
      this.order_id = this.$route.query.id;
      this.getOrderDetail();
    }
  },
  methods: {
    getOrderDetail() {
      let data = {
        order_id: this.order_id,
      };
      http.post("/api/wap/order/fuinfo", data).then((res) => {
        this.order_detail = res.data;
      });
    },
    numProcess(val){
      return Number(val).toFixed(2)
    }
  },
};
</script>
<style scoped>
@import "./issue_detail.css";
</style>



// WEBPACK FOOTER //
// src/pages/user/issue_detail.vue